export function InvoiceChecking({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <g id="Group_16836" data-name="Group 16836" transform="translate(-865 -172)">
        <g
          id="Rectangle_10299"
          data-name="Rectangle 10299"
          transform="translate(865 172)"
          fill="#fff"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="24" height="24" stroke="none" />
          <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
        </g>
        <path
          id="Path_41471"
          data-name="Path 41471"
          d="M1892.889,3638.1h-5.333m1.778,3.6h-1.778m7.111-7.2h-7.111m10.667,3.15v-3.33a6.717,6.717,0,0,0-.293-2.844,2.565,2.565,0,0,0-1.164-1.179,6.483,6.483,0,0,0-2.809-.3h-5.689a6.483,6.483,0,0,0-2.809.3,2.565,2.565,0,0,0-1.164,1.179,6.717,6.717,0,0,0-.293,2.844v9.36a6.715,6.715,0,0,0,.293,2.844,2.564,2.564,0,0,0,1.164,1.179,6.478,6.478,0,0,0,2.809.3h2.4m9.333,0-1.333-1.35m.889-2.25a3.111,3.111,0,1,1-3.111-3.15A3.134,3.134,0,0,1,1899.556,3644.4Z"
          transform="translate(-1015 -3455)"
          fill="rgba(0,0,0,0)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.64"
        />
      </g>
    </svg>
  );
}
